export default __webpack_public_path__ + "static/media/video_consult.ada36e66.jpg";